import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ConfirmationOverlay = _resolveComponent("ConfirmationOverlay")!

  return (_openBlock(), _createBlock(_component_ConfirmationOverlay, {
    acceptTheme: "primary",
    rejectTheme: "return",
    "bold-title": true,
    titleText: "Please confirm you would like to attach to this trailer.",
    "subtitle-text": `Trailer #${_ctx.trailerNumber}`,
    "subtitle-style": "strong-subtitle",
    image: _ctx.trailerCompany,
    acceptText: "Yes, continue to assessment",
    rejectText: "Cancel",
    onAccept: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('accept'))),
    onReject: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('reject'))),
    "full-screen": _ctx.isFullScreen
  }, null, 8, ["subtitle-text", "image", "full-screen"]))
}